export class Area {
    id : number;
    areaCode : string;
    areaName : string;
}